export default class UsersService {
  static async getMe(token) {
    const apiUrl = window.env.API_URL;
    const response = await fetch(`${apiUrl}/api/v1/users/me`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) throw new Error('Failed to fetch user info');
    return response.json();
  }

  // Future endpoints - ready for implementation
  static async getAllUsers(token, searchTerm = '', page = 0, size = 20, sort = 'email,asc') {
    const apiUrl = window.env.API_URL;
    
    // Build query parameters
    const params = new URLSearchParams({
      page: page.toString(),
      size: size.toString(),
      sort: sort
    });
    
    if (searchTerm && searchTerm.trim()) {
      params.append('searchTerm', searchTerm.trim());
    }
    
    const response = await fetch(`${apiUrl}/api/v1/users?${params}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) throw new Error('Failed to fetch users');
    return response.json();
  }

  static async updateUser(userId, userData, token) {
    const apiUrl = window.env.API_URL;
    const response = await fetch(`${apiUrl}/api/v1/users/${userId}`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(userData),
    });
    if (!response.ok) throw new Error('Failed to update user');
    
    // Handle 204 No Content response (e.g., for company association/dissociation)
    if (response.status === 204) {
      return null; // No response body
    }
    
    // Check if response has content before parsing JSON
    const contentLength = response.headers.get('content-length');
    if (contentLength === '0') {
      return null; // Empty response body
    }
    
    const text = await response.text();
    if (!text.trim()) {
      return null; // Empty or whitespace-only response
    }
    
    return JSON.parse(text);
  }

  static async deleteUser(userId, token) {
    const apiUrl = window.env.API_URL;
    const response = await fetch(`${apiUrl}/api/v1/users/${userId}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) throw new Error('Failed to delete user');
    
    // Handle 204 No Content response
    if (response.status === 204) {
      return null; // No response body
    }
    
    return response.json();
  }

  static async updateUserRoles(userId, roles, token) {
    throw new Error('Update user roles endpoint not yet implemented in API');
  }

  static async enableUser(userId, token) {
    const apiUrl = window.env.API_URL;
    const response = await fetch(`${apiUrl}/api/v1/users/${userId}/enable`, {
      method: 'PATCH',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) throw new Error('Failed to enable user');
    return response.status === 204; // No content means success
  }

  static async disableUser(userId, token) {
    const apiUrl = window.env.API_URL;
    const response = await fetch(`${apiUrl}/api/v1/users/${userId}/disable`, {
      method: 'PATCH',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) throw new Error('Failed to disable user');
    return response.status === 204; // No content means success
  }

  static async createUser(userData, token) {
    const apiUrl = window.env.API_URL;
    const response = await fetch(`${apiUrl}/api/v1/users`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(userData),
    });
    
    if (response.status === 409) {
      throw new Error('Email is already in use');
    }
    if (!response.ok) throw new Error('Failed to create user');
    
    return response.json();
  }

  static async resetPassword(userId, newPassword, token) {
    const apiUrl = window.env.API_URL;
    const response = await fetch(`${apiUrl}/api/v1/users/${userId}/reset-password`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ newPassword }),
    });
    if (!response.ok) throw new Error('Failed to reset password');
    return response.status === 204; // No content means success
  }
}
